import React from 'react';
import { Skeleton } from '@mui/material';

export const CardSkeleton = () => {
  return <Skeleton variant="rounded" height="10rem" width="100%" />;
};
